var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 257,
    viewBox: "0 0 136 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5942 1.69452C17.3291 0.588934 21.3056 0.598032 25.0354 1.7207L121.764 30.8358C130.215 33.3795 136 41.1616 136 49.987V142.416C136 205.699 83.7302 257 19.2522 257C-46.0567 257 -99 205.038 -99 140.94V49.9614C-99 41.1021 -93.1717 33.2985 -84.6767 30.7839L13.5942 1.69452ZM-29.8747 70.7411C-38.3696 73.2557 -44.198 81.0592 -44.198 89.9185V140.94C-44.198 175.333 -15.7904 203.214 19.2522 203.214C53.4639 203.214 81.198 175.994 81.198 142.416V89.7505C81.198 80.9251 75.4133 73.1429 66.9624 70.5992L24.9023 57.9393C21.1725 56.8166 17.196 56.8075 13.4611 57.9131L-29.8747 70.7411Z",
    fill: "#CDDEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTop);
export default __webpack_public_path__ + "static/media/box-top.ac8491a535f019c726fa7a0f78d66e86.svg";
export { ForwardRef as ReactComponent };